module.exports = {
    "collapse": `Samenvouwen`,
    "expand": `Uitvouwen`
};


//# sourceMappingURL=nl-NL.main.js.map
